import { createSlice } from "@reduxjs/toolkit";
import { iAddPurchaseOrderState, REDUCER_NAME } from "./Types";
import { createPurchaseOrder } from "./ThunkAction";

const initialState: iAddPurchaseOrderState = {
  isLoading: false,
  isSuccess: false,
  error: null,
  orderData: null,
};

const addPurchaseOrderSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    resetAddPurchaseOrderState: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.error = null;
      state.orderData = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createPurchaseOrder.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.error = null;
      })
      .addCase(createPurchaseOrder.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.orderData = action.payload;
      })
      .addCase(createPurchaseOrder.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetAddPurchaseOrderState } = addPurchaseOrderSlice.actions;
export default addPurchaseOrderSlice.reducer;
